<template>
  <div class="details-list">
    <div class="detail-item">
      <span>Role:</span>
      <pl-select
        v-if="hasAdminAdminPermission"
        class="pa0"
        :options="['student', 'teacher']"
        :selected="user.role"
        @change="changeUserRole(user, $event)"
        :isLoading="user.id === loadingUserId"
        :disabled="user.id === loadingUserId"
        :arrow="true"
        style="text-transform: capitalize"
      ></pl-select>
      <span v-else style="text-transform: capitalize">{{ user.role }} </span>
    </div>
    <div class="detail-item" v-if="user.user_school">
      <span>School Role:</span>
      <pl-select
        v-if="canChangePrivileges"
        class="pa0"
        :options="['student', 'teacher']"
        :selected="user.user_school[0].role"
        @change="changeUserSchoolRole(user, $event)"
        :isLoading="user.id === loadingSchoolRoleUserId"
        :disabled="user.id === loadingSchoolRoleUserId"
        :arrow="true"
        style="text-transform: capitalize"
      ></pl-select>
      <span v-else style="text-transform: capitalize"
        >{{ user.user_school[0].role }}
      </span>
    </div>
    <div class="detail-item">
      <span>Email:</span>
      <div>
        <span :class="adminPortalUser ? '' : 'pr2'">{{ user.email }}</span>
        <pl-menu v-if="adminPortalUser" :menuSize="3" direction="right">
          <pl-button
            slot="menu_trigger"
            class="pl-icon"
            style="
              margin: 0px;
              padding: 0;
              min-width: 20px;
              min-height: 20px;
              line-height: 20px;
              font-size: 12px;
            "
          >
            <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
          </pl-button>
          <ul menu-content>
            <li @click="editUserEmail">Edit User Email</li>
          </ul>
        </pl-menu>
      </div>
    </div>
    <div class="detail-item">
      <span>Account Created:</span>
      <span class="pr2">{{ accountCreated }}</span>
    </div>
    <!-- Commented until we add last active date to users -->
    <!-- <div class="detail-item">
      <span>Last Active:</span>
      <span>{{ lastActive }}</span>
    </div> -->
    <div v-if="isTeacher && user.profile_url" class="detail-item">
      <span>Universe Portfolio:</span>
      <span class="portfolio-link">
        <a
          class="flex"
          :href="getFullProfileURL(user.profile_url)"
          target="_blank"
        >
          {{ user.profile_url }}
          <i
            class="fas fa-external-link-alt"
            @click="goToUniverse(user.profile_url)"
          ></i>
        </a>
        <!-- {{ user.profile_url }}
        <i class="fas fa-external-link-alt"></i> -->
      </span>
    </div>
    <div v-if="user.user_school" class="detail-item">
      <span>School Site:</span>
      <pl-select
        v-if="canChangePrivileges"
        class="pa0 col-xs-6"
        :options="school_sites"
        :selected="user.schoolSite ? user.schoolSite.name : 'No Site'"
        @change="updateUserSchoolSite(user, $event)"
        :isLoading="user.id === loadingUserSchoolSiteId"
        :disabled="user.id === loadingUserSchoolSiteId"
        :arrow="true"
      ></pl-select>
      <span v-else
        >{{ user.schoolSite ? user.schoolSite.name : 'No Site' }}
      </span>
    </div>
    <div
      v-if="isTeacher && user.user_school && user.user_school[0]"
      class="detail-item"
    >
      <span>Admin Privileges:</span>
      <pl-select
        v-if="canChangePrivileges"
        class="pa0"
        :options="['coach', 'admin', 'none']"
        :selected="user.user_school[0].admin_role"
        @change="updateSchoolUserAdminRole(user, $event)"
        :isLoading="user.id === loadingAdminRoleUserId"
        :disabled="user.id === loadingAdminRoleUserId"
        :arrow="true"
        style="text-transform: capitalize"
      ></pl-select>
      <span v-else style="text-transform: capitalize"
        >{{ user.user_school[0].admin_role }}
      </span>
    </div>
    <div v-if="isTeacher" class="detail-item">
      <span>Subjects:</span>
      <div class="subjects-list pr2">
        <span v-for="(subject, index) in user.subjects" :key="index">
          {{ subject.name }}{{ index < user.subjects.length - 1 ? ',' : '' }}
        </span>
      </div>
    </div>
    <div v-if="isTeacher" class="detail-item">
      <span>Grade Levels:</span>
      <div class="grades-list pr2">
        <span v-for="(grade, index) in user.grade_levels" :key="index">
          {{ grade.grade }}
          {{ index < user.grade_levels.length - 1 ? ',&nbsp' : '' }}
        </span>
      </div>
    </div>
    <div v-if="adminPortalUser" class="detail-item">
      <span>Active Passes</span>
      <div class="tr pa0">
        <div>
          Current Unused passes: {{ user_membership_details.activity_passes }}
        </div>
        <div>
          <input
            v-model="passes_to_create"
            type="number"
            min="1"
            class="passes-create-input"
          />
          <pl-button
            @click.native="createActivityPasses"
            class="pl-primary"
            style="margin-right: 0px"
          >
            Create More
          </pl-button>
        </div>
      </div>
    </div>
    <div v-if="adminPortalUser" class="detail-item">
      <span>Active Memberships</span>
      <div class="f7">
        <div
          class="mt2"
          v-for="membership in active_memberships"
          :key="membership.id"
        >
          <strong>Expiry Date</strong>:
          {{ membership.end_date_readable }}
          <br />
          <strong>Date Started</strong>: {{ membership.start_date_readable }}
          <br />
          <strong>Membership Type</strong>: {{ membership.membership.type }}
        </div>
        <div class="mt2">
          <div class="fr">
            <div>
              <label for="start">Start Date</label>
              <input
                v-model="start_date"
                type="date"
                id="start"
                name="membership-selection"
                required
                style="margin-right: 0px"
              />
            </div>
            <div>
              <label for="end">End Date</label>
              <input
                v-model="end_date"
                type="date"
                id="end"
                name="membership-selection"
                required
                style="margin-right: 0px"
                class="fr"
              />
            </div>
          </div>

          <div class="">
            <pl-button
              :disabled="Boolean(!(start_date && end_date))"
              class="pl-primary fr"
              style="margin-right: 0px"
              @click.native="createNewUserMembership"
            >
              Create New
            </pl-button>
          </div>
        </div>
      </div>
    </div>
    <edit-user-email-modal
      v-if="adminPortalUser && show_edit_user_email_modal"
      :user="user"
      @close="show_edit_user_email_modal = false"
      @update-user-email="updateUserEmail"
    />
  </div>
</template>

<script>
  import moment from 'moment';
  import config from 'services/apiConfigs';
  import { mapGetters } from 'vuex';
  import { EventBus } from 'utils/event-bus';
  import adminServices from 'services/admin/adminServices';
  import editUserEmailModal from 'components/modals/editUserEmailModal';

  export default {
    data() {
      return {
        loadingUserId: '',
        loadingAdminRoleUserId: '',
        loadingUserSchoolSiteId: '',
        loadingSchoolRoleUserId: '',
        show_edit_user_email_modal: false,
        user_membership_details: {
          user_memberships: [],
          activity_passes: 0,
          role: 'student',
        },
        passes_to_create: 1,
        start_date: '',
        end_date: '',
      };
    },
    components: {
      editUserEmailModal,
    },
    props: {
      user: {
        type: Object,
        default() {
          return {};
        },
      },
      schoolSites: {
        type: Array,
        default: [],
      },
      userId: {
        type: String,
        default() {
          return '';
        },
      },
    },
    computed: {
      ...mapGetters(['hasAdminAdminPermission', 'getProfile']),
      isTeacher() {
        if (this.user) {
          return this.user.role === 'teacher';
        } else {
          return false;
        }
      },
      adminPortalUser() {
        if (this.getProfile.role === 'admin') {
          return true;
        } else {
          return false;
        }
      },
      accountCreated() {
        return this.user.created_at
          ? moment(this.user.created_at).format('MM-DD-YYYY')
          : 'no date';
      },
      canChangePrivileges() {
        return (
          this.hasAdminAdminPermission &&
          this.user.user_school &&
          this.user.user_school.length &&
          this.user.id !== this.getProfile.id
        );
      },
      lastActive() {
        return this.user.lastActive
          ? moment(this.user.lastActive).format('MM-DD-YYYY')
          : 'Work in Progress';
      },
      school_sites() {
        return this.schoolSites.map((site) => site.name).concat('No Site');
      },
      expired_memberships() {
        return this.user_membership_details.user_memberships.filter(
          (membership) => {
            return moment().isAfter(membership.end_date);
          }
        );
      },
      active_memberships() {
        return this.user_membership_details.user_memberships.filter(
          (membership) => {
            return moment().isBefore(membership.end_date);
          }
        );
      },
    },
    methods: {
      goToUniverse(profile_url) {
        if (profile_url) {
          window.open(`${config.universeURL}/profiles/${profile_url}`);
          window.location.reload();
        }
      },
      getFullProfileURL(profile_url) {
        return `${config.universeURL}/profiles/${profile_url}`;
      },
      changeUserRole(user, role) {
        if (
          role &&
          user.id &&
          user.role !== role &&
          this.hasAdminAdminPermission
        ) {
          this.loadingUserId = user.id;
          const payload = { role: role };
          adminServices
            .adminUpdateUser(user.id, payload)
            .then(() => {
              EventBus.$emit('toast-msg', 'User Role changed to ' + role + '.');
              // update user on the table
              const userUpdated = user;
              userUpdated.role = role;
              // the object is different so the events are different
              EventBus.$emit('update-user-role-event', userUpdated);
              EventBus.$emit('update-userDetails-event', userUpdated);
              this.loadingUserId = '';
            })
            .catch((error) => {
              EventBus.$emit('toast-msg', error.response.data.message);
              this.loadingUserId = '';
              console.error(error);
            });
        }
      },
      changeUserSchoolRole(user, schoolRole) {
        const schoolID = this.$route.params.schoolID || user.schoolID;
        if (
          schoolRole &&
          user.id &&
          user.user_school &&
          user.user_school[0].role !== schoolRole &&
          this.hasAdminAdminPermission
        ) {
          this.loadingSchoolRoleUserId = user.id;
          const payload = { role: schoolRole };
          adminServices
            .updateUserSchoolRole(schoolID, user.id, payload)
            .then((userData) => {
              EventBus.$emit(
                'toast-msg',
                'User School Role changed to ' + schoolRole + '.'
              );
              // update user on the table
              const userUpdated = user;
              if (
                userData &&
                userUpdated.user_school &&
                userUpdated.user_school[0].role
              ) {
                userUpdated.user_school[0].role = schoolRole;
                // the object is different so the events are different
                EventBus.$emit('update-user-school-role-event', userUpdated);
                EventBus.$emit('update-userDetails-event', userUpdated);
              }
              this.loadingSchoolRoleUserId = '';
            })
            .catch((error) => {
              const error_message =
                error.response.data.error || error.response.data.message;
              EventBus.$emit('toast-msg', error_message);
              this.loadingSchoolRoleUserId = '';
              console.error(error);
            });
        }
      },
      updateSchoolUserAdminRole(user, adminRole) {
        const schoolID = this.$route.params.schoolID || user.schoolID;
        if (
          schoolID &&
          user.id &&
          user.user_school &&
          user.user_school[0].admin_role !== adminRole
        ) {
          this.loadingAdminRoleUserId = user.id;
          const payload = {
            role: adminRole,
          };
          this.$store
            .dispatch('updateSchoolUserAdminRole', {
              schoolID,
              userID: user.id,
              payload: payload,
            })
            .then((userData) => {
              this.loadingAdminRoleUserId = '';
              const userUpdated = user;
              if (
                userData &&
                userUpdated.user_school &&
                userUpdated.user_school[0].admin_role
              ) {
                userUpdated.user_school[0].admin_role = adminRole;
                // the object is different so the events are different
                EventBus.$emit('update-user-admin-role-event', userUpdated);
                EventBus.$emit('update-userDetails-event', userUpdated);
              }
            })
            .catch((error) => {
              EventBus.$emit('toast-msg', error.response.data.message);
              this.loadingAdminRoleUserId = '';
              console.error(error);
            });
        }
      },
      updateUserSchoolSite(user, site) {
        const schoolID = this.$route.params.schoolID || user.schoolID;
        if (user.id && schoolID) {
          this.loadingUserSchoolSiteId = user.id;
          const site_object = this.schoolSites.find((s) => s.name === site);
          const payload = {
            site_id: site_object ? site_object.id : null,
            site: site_object ? site_object.name : 'No Site',
          };
          this.$store
            .dispatch('updateUserSchoolSite', {
              schoolID,
              userID: user.id,
              payload: payload,
            })
            .then(() => {
              EventBus.$emit('toast-msg', 'User School Site updated');
              this.loadingUserSchoolSiteId = '';
              if (user.schoolSite && user.schoolSite.name) {
                user.schoolSite.name = site;
              } else {
                const schoolSiteAux = {
                  id: site_object.id,
                  name: site,
                };
                user.schoolSite = schoolSiteAux;
              }
              EventBus.$emit('update-user-school-site-event', user);
              EventBus.$emit('update-userDetails-event', user);
            })
            .catch((error) => {
              EventBus.$emit('toast-msg', error.response.data.message);
              this.loadingUserSchoolSiteId = '';
              console.error(error);
            });
        }
      },
      editUserEmail() {
        this.show_edit_user_email_modal = true;
      },
      updateUserEmail(value) {
        this.$emit('update-user-email', value);
        EventBus.$emit('update-user-email-users-table', value);
      },
      createNewUserMembership() {
        if (!(this.start_date && this.end_date)) {
          return;
        }
        adminServices
          .upgradeTeacher(this.userID, {
            start_date: this.start_date,
            end_date: this.end_date,
          })
          .then((res) => {
            this.start_date = '';
            this.end_date = '';
            this.user_membership_details.user_memberships.push(res.data);
          })
          .catch();
      },
      createActivityPasses() {
        adminServices
          .createActivityPasses(this.userID, this.passes_to_create)
          .then(() => {
            this.user_membership_details.activity_passes =
              parseInt(this.user_membership_details.activity_passes) +
              parseInt(this.passes_to_create);
            this.passes_to_create = 1;
          })
          .catch();
      },
    },

    created() {
      if (this.adminPortalUser) {
        adminServices
          .getUser(this.userId)
          .then((res) => {
            this.user_membership_details = res.data;
            this.userID = res.data.id;
          })
          .catch();
      }
    },
  };
</script>

<style scoped lang="stylus">
  @import '~app/global-stylus'

  .details-list
    .detail-item
      display flex
      justify-content space-between
      padding .5rem
      border-bottom 1px solid pl-fog
      color pl-charcoal

  .portfolio-link
    a
      color: #78BEC8
      :hover
        text-decoration underline
      i
        align-self start
        font-size 6px
        padding 4px

  .subjects-list
    text-align: right
  .grades-list
    text-align: right

  button.pl-icon
    height: 20px
    width: 20px
    min-width: 20px
</style>
<style lang="stylus">
  .details-list
    overflow-y: scroll
    max-height: 60vh
    .detail-item
      .custom-select
        padding 0
        width 33%
        .selected
          padding: 0 0.5rem;
          height: 20px;
          margin-top: 0;
          justify-content flex-end
          span
            padding 0 .5rem
          .fa-sort-down
            margin-top -4px;

    .passes-create-input
      width:50px;
      height: 36px;
      border: 1px solid #AAA8A8
      border-radius: 5px;

  ::-webkit-scrollbar {
    display: block;
    width: 10px
    -webkit-appearance: none;
  }
</style>



// WEBPACK FOOTER //
// detailsTabContent.vue?1dce483e